import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {BruteForceGameAssets} from "./BruteForceGameAssets";
import {BruteForceSound} from "./sound/BruteForceSound";
import {BruteForceBackgroundElements} from "./view/BruteForceBackgroundElements";
import {BruteForceWinPresentation} from "./gameflow/BruteForceWinPresentation";
import {BruteForceNormalBetPresentation} from "./gameflow/BruteForceNormalBetPresentation";
import {BruteForceNormalResultPresentation} from "./gameflow/BruteForceNormalResultPresentation";
import {BruteForceIdleNormalPresentation} from "./gameflow/BruteForceIdleNormalPresentation";
import {BruteForceZeroBetIdlePresentation} from "./gameflow/BruteForceZeroBetIdlePresentation";
import {BruteForceGameData, ISymbolValues} from "./server/BruteForceData";
import {BruteForceModel} from "./server/BruteForceModel";
import {BruteForceReelsArea} from "./reels/BruteForceReelsArea";
import {BruteForceForegroundElements} from "./view/BruteForceForegroundElements";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {BruteForceBonusIntro} from "./view/BruteForceBonusIntro";
import {BruteForceBonusOutro} from "./view/BruteForceBonusOutro";
import {BruteForceReelOverlayView} from "./view/BruteForceReelOverlayView";
import {BruteForceIndividualWinView} from "./view/BruteForceIndividualWinView";
import {BruteForceTotalWinCountupView} from "./view/BruteForceTotalWinCountupView";
import {BruteForceBetLineView} from "./view/BruteForceBetLineView";
import {BruteForceBigWinView} from "./view/BruteForceBigWinView";
import {BruteForceWinCapView} from "./view/BruteForceWinCapView";
import {BruteForceMiniPayTable} from "./view/BruteForceMiniPayTable";
import {BruteForceAnticipationView} from "./view/BruteForceAnticipationView";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BruteForceGameIntro} from "./intro/BruteForceGameIntro";
import {BruteForceTransitionScreen} from "./view/BruteForceTransitionScreen";
import {BruteForceTransitionShutterView} from "./view/BruteForceTransitionShutterView";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {
    BonusFeatureDisplayConfigurationList
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {BruteForceReelScreenDarkOverlayView} from "./view/BruteForceReelScreenDarkOverlayView";
import {ParticlesManager} from "./components/particles/ParticlesManager";
import {RestoreUtils} from "./utils/RestoreUtils";
import {BruteForceGameView} from "./view/BruteForceGameView";
import {BruteForceGameMode} from "./server/BruteForceGameMode";
import {Speedster} from "./utils/Speedster";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";


export class BruteForce extends SlotGame {
    public static model: BruteForceModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: BruteForceSound;
    public static backgroundElements: BruteForceBackgroundElements;
    public static foregroundElements: BruteForceForegroundElements;
    public static gameFlowController: GameFlowController;
    public static allreelsView: BruteForceReelsArea;
    public static bonusIntroView: BruteForceBonusIntro;
    public static bonusOutroView: BruteForceBonusOutro;
    public static reelOverlayView: BruteForceReelOverlayView;
    public static individualWinView: BruteForceIndividualWinView;
    public static totalWinView: BruteForceTotalWinCountupView;
    public static betlineView: BruteForceBetLineView;
    public static bigWinView: BruteForceBigWinView;
    public static wincapView: BruteForceWinCapView;
    public static miniPayTable: BruteForceMiniPayTable;
    public static anticipationView: BruteForceAnticipationView;
    public static gameIntroView: BruteForceGameIntro;
    public static transitionView: BruteForceTransitionScreen;
    public static transitionShutter: BruteForceTransitionShutterView;
    public static reelScreenDarkOverlay: BruteForceReelScreenDarkOverlayView;
    public static particleManager: ParticlesManager;
    public static gameContainer: BruteForceGameView;
    public static isActionSpinsActive: boolean = false;
    private _allBetLevels: string[] = [];
    private _defaultSymbolValues: ISymbolValues = {
        "M1": {3: 40, 4: 200, 5: 400},
        "M2": {3: 20, 4: 100, 5: 200},
        "L1": {3: 5, 4: 20, 5: 40},
        "M3": {3: 20, 4: 100, 5: 200},
        "L2": {3: 5, 4: 20, 5: 40},
        "XN": {3: 40, 4: 200, 5: 400},
        "M4": {3: 10, 4: 50, 5: 100},
        "L3": {3: 5, 4: 20, 5: 40},
        "M5": {3: 10, 4: 50, 5: 100},
        "L4": {3: 5, 4: 20, 5: 40},
        "L5": {3: 5, 4: 20, 5: 40}
    }


    private skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady() : Promise<any>{
        if (this.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            //Bonus
            replaceMap.set("xBet", "xbet.png")
            replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }


    public getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol" style="position: relative">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <img src="{{gamePath}}screens/images/symbols/texture.png" style="position: absolute;opacity: 0.2">
            <div class="payout-group">
                 <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;


    }

    private paytable:string = require("../../nolimit/screens/paytable.mustache");

    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            let symbolDataValueData = this._defaultSymbolValues;
            if (BruteForce.model.initData.symbolValues) {
                symbolDataValueData = BruteForce.model.initData.symbolValues;
                console.log("Using symbolValues from INIT data");
            } else {
                console.log("Using default symbolValues ");
            }
            const data = {
                skinPath: "screens/images/"
            };
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            for (let key in symbolDataValueData) {
                paytableString = paytableString.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
            }
            resolve(paytableString);
        });
    }

    getNoWinGameData(): any {
        return {
            "reels": [["L5", "L1", "L4", "M1", "L3", "M3", "M2"], ["L3", "M3", "M3", "M3", "L1", "L5", "M1"], ["L4", "L4", "L4", "M2", "L5", "L1", "M4"], ["M4", "M5", "M5", "M5", "L3", "L4", "L5"], ["M5", "M4", "M3", "L3", "L4", "L1", "M2"]],
            "evaluatedArea": [["L1", "L4", "M1", "L3", "M3"], ["M3", "M3", "M3", "L1", "L5"], ["L4", "L4", "M2", "L5", "L1"], ["M5", "M5", "M5", "L3", "L4"], ["M4", "M3", "L3", "L4", "L1"]],
            "betLineWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "boostedBet": false,
            "brokeTheBank": false,
            "freespinsTriggeredThisSpin": false,
            "freespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinsWinnings": 0,
            "serverTestInfo": {},
            "xNudgeMultipliers": [0, 0, 0, 0, 0],
            "xNudgeLevels": [0, 0, 0, 0, 0],
            "xNudgeSticky": [false, false, false, false, false],
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            BruteForce.model = new BruteForceModel(SlotGame.apiPlugin, true);
            BruteForce.gameFlowController = new GameFlowController(SlotGame.apiPlugin, BruteForce.model);
            BruteForce.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            //Example
            BruteForce.model.events?.on(GameModelEvent.GAME, (data: BruteForceGameData) => {
                console.log(data);
            });

            const idleNormal = new BruteForceIdleNormalPresentation();
            const reelStart = new BruteForceNormalBetPresentation();
            const normalResult = new BruteForceNormalResultPresentation();
            const zeroBetIdle = new BruteForceZeroBetIdlePresentation();
            const winPres = new BruteForceWinPresentation();

            BruteForce.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            BruteForce.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            BruteForce.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));

            BruteForce.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, (data: any) => {
                if (BruteForce.model.mode === BruteForceGameMode.NORMAL || (BruteForce.model.mode !== BruteForceGameMode.NORMAL && BruteForce.model.nextMode === BruteForceGameMode.NORMAL)) {
                    BruteForce.anticipationView.updateXBetState();
                }
                BruteForceSound.playFeatureSound();
                BruteForce.gameContainer.updateNudgeScreenState();
            });


            BruteForce.apiPlugin.events.on(APIEvent.BET_LEVELS, (data: any): void => {
                this._allBetLevels = data.availableBetLevels;
            })

            BruteForce.apiPlugin.events.on(APIEvent.CURRENT_BET, (data: any): void => {
                if (this._allBetLevels.indexOf(data) > -1) {
                    BruteForceSound.playTrack(BruteForceSound.BET_CHANGE[this._allBetLevels.indexOf(data)]);
                }
            })

            BruteForce.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
                if (data) {
                    idleNormal.presentationComplete();
                }
                /*  else {
                      BruteForce.reelView.reelModels.forEach((reel: SimpleReelModel) => {
                          reel.setInteractiveSymbols(true);
                      });
                  }*/
                BruteForce.isActionSpinsActive = !!data; // sometimes data can be undefined
            });
            this.handleSweepInit();
            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            fontLoader.add({
                family: "ARCADECLASSIC",
                weight: FontWeight.NORMAL,
                style: FontStyle.NORMAL,
                url: "/resources/fonts/ARCADECLASSIC.ttf"
            });
            fontLoader.add({
                family: "AMCAP Eternal",
                weight: FontWeight.NORMAL,
                style: FontStyle.NORMAL,
                url: "/resources/fonts/AMCAP Eternal.ttf"
            });
            fontLoader.add({
                family: "Guardians",
                weight: FontWeight.NORMAL,
                style: FontStyle.NORMAL,
                url: "/resources/fonts/Guardians.ttf"
            });

            AssetsConfig.addToAssetsConfig(BruteForceGameAssets.RESOURCES_GROUPS);
            BruteForce.assetLoader = new AssetLoader(BruteForce.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), BruteForce.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();

                RestoreUtils.startupGame();

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            BruteForceSound.switchMusic({name: BruteForceSound.MAIN_GAME_MUSIC});
            BruteForceSound.playTrack(BruteForceSound.MAIN_GAME_MUSIC_CRUSHED, 0);
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            BruteForce.gameFlowController.start();
            BruteForce.backgroundElements.setMode(BruteForce.model.mode);
            if (BruteForce.model.nextMode.includes("NORMAL") && !BruteForce.model.isRestore && BruteForce.model.mode === "NORMAL") {
                if (!BruteForce.apiPlugin.isReplay) {
                    BruteForce.gameIntroView.startIntro();
                }
            }
            if (BruteForce.model.mode === "FREESPIN") {
                BruteForceSound.switchMusic({name: BruteForceSound.FS_MUSIC});
            } else if (BruteForce.model.mode === "FREESPIN_SUPER") {
                BruteForceSound.switchMusic({name: BruteForceSound.SFS_MUSIC});
            }
            return value;
        });
    }

    public getNolimitBonusDisplayConfiguration(): BonusFeatureDisplayConfigurationList {

        return {
            LUCKY_DRAW: {
                displayName: "LUCKY_DRAW",
                displayOrder: 0,
            },
            FREESPIN_3_SCATTERS: {
                displayName: "FREESPIN_3_SCATTERS",
                displayOrder: 1,
            },
            FREESPIN_4_SCATTERS: {
                displayName: "FREESPIN_4_SCATTERS",
                displayOrder: 2,
            },
            BOOSTED_BET: {
                displayName: "BOOSTED_BET",
                displayOrder: 3,
                replacePopUpContent: (content: BonusBuyPopUpContent) => {
                    const warningTextText: string = "10 times more likely to trigger Freespins.";
                    const warningText = new Label(BruteForce.apiPlugin.translations.translate(warningTextText),
                        content.textLabel.getStyleClone());
                    warningText.scale.set(0.75, 0.75);
                    warningText.anchor.set(0.5, 0.5);
                    warningText.position.set(0, 375);
                    content.addChild(warningText);

                    content.textLabel.scale.set(0.75, 0.75);
                    content.textLabel.position.y -= 30;

                    return content;
                }
            },
            GUARANTEED_X_NUDGE: {
                displayName: "GUARANTEED_X_NUDGE",
                displayOrder: 4,
            },
            GUARANTEED_X_NUDGE_2: {
                displayName: "GUARANTEED_X_NUDGE_2",
                displayOrder: 5,
            },
            GUARANTEED_X_NUDGE_4: {
                displayName: "GUARANTEED_X_NUDGE_4",
                displayOrder: 6,
            },
        }

    }

    private createViewsAndComponents() {
        //Non views
        BruteForce.soundPlayer = new BruteForceSound();
        BruteForce.particleManager = new ParticlesManager();

        //Static views
        BruteForce.backgroundElements = new BruteForceBackgroundElements();

        BruteForce.foregroundElements = new BruteForceForegroundElements();


        BruteForce.allreelsView = new BruteForceReelsArea();
        BruteForce.bonusIntroView = new BruteForceBonusIntro();
        BruteForce.bonusOutroView = new BruteForceBonusOutro();
        BruteForce.reelOverlayView = new BruteForceReelOverlayView();
        BruteForce.miniPayTable = new BruteForceMiniPayTable(BruteForce.model.initData.symbolValues);
        BruteForce.individualWinView = new BruteForceIndividualWinView();
        BruteForce.totalWinView = new BruteForceTotalWinCountupView();
        BruteForce.betlineView = new BruteForceBetLineView();
        BruteForce.bigWinView = new BruteForceBigWinView();
        BruteForce.wincapView = new BruteForceWinCapView();
        BruteForce.anticipationView = new BruteForceAnticipationView();
        BruteForce.gameIntroView = new BruteForceGameIntro();
        BruteForce.transitionView = new BruteForceTransitionScreen();
        BruteForce.transitionShutter = new BruteForceTransitionShutterView();
        BruteForce.reelScreenDarkOverlay = new BruteForceReelScreenDarkOverlayView();
        BruteForce.gameContainer = new BruteForceGameView();

        NolimitApplication.addLayerAt(BruteForce.gameContainer.name, BruteForce.gameContainer, 0)

        BruteForce.gameContainer.addChild(BruteForce.backgroundElements);
        BruteForce.gameContainer.addChild(BruteForce.allreelsView);
        BruteForce.gameContainer.addChild(BruteForce.reelOverlayView);
        BruteForce.gameContainer.addChild(BruteForce.anticipationView);
        BruteForce.gameContainer.addChild(BruteForce.individualWinView);
        BruteForce.gameContainer.addChild(BruteForce.betlineView);
        BruteForce.gameContainer.addChild(BruteForce.totalWinView);
        BruteForce.gameContainer.addChild(BruteForce.transitionShutter);
        BruteForce.gameContainer.addChild(BruteForce.bonusIntroView);
        BruteForce.gameContainer.addChild(BruteForce.bonusOutroView);
        BruteForce.gameContainer.addChild(BruteForce.gameIntroView);
        BruteForce.gameContainer.addChild(BruteForce.foregroundElements);
        BruteForce.gameContainer.addChild(BruteForce.miniPayTable);
        BruteForce.gameContainer.addChild(BruteForce.wincapView);
        BruteForce.gameContainer.makeNudgeScreenAtTop();
        BruteForce.gameContainer.addChild(BruteForce.reelScreenDarkOverlay);
        BruteForce.gameContainer.addChild(BruteForce.bigWinView);

        NolimitApplication.addLayerAt(BruteForce.transitionView.name, BruteForce.transitionView, 1)
        NolimitApplication.addLayer("Speedster", new Speedster());
    }
}